module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask",
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container center",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("x")]), _vm._v(" "), _c('div', {
    staticClass: "modal-header"
  }, [_vm._t("modal-header", [_c('h5', {
    staticClass: "bold"
  })])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("modal-body")], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("modal-footer")], 2), _vm._v(" "), _vm._t("loader")], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24184648","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal.vue
// module id = 364
// module chunks = 0